import storage from '/src/utils/storage';
import hasPermission from '/src/utils/hasPermission';

export default function canMakeReview() {
    const user = storage('local').get('user');
    return Boolean(user?.is_admin || hasPermission('make_review'));
}
